import React from "react";

import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { TextField } from "@mapmycustomers/ui";

import GoalType from "@app/enum/dashboard/GoalType";

import getTargetFieldLabel from "./getTargetFieldLabel";

interface Props {
  goalType: GoalType;
  value?: number;
}

const AmountDetails: React.FC<Props> = ({ goalType, value }) => {
  const intl = useIntl();

  return (
    <TextField
      disabled
      label={getTargetFieldLabel(intl, goalType)}
      suffix={<FontAwesomeIcon icon={faLock} />}
      value={String(value ?? 0)}
    />
  );
};

export default AmountDetails;
